import { REFERRAL_ACTIONS } from '../actions/actionTypes';

// `searchParams` starts empty so the list's first fetch is never mistaken
// for a repeat of the last one by fetchReferrals's dedup check.
const defaultState = {
  referrals: [],
  totalReferrals: 0,
  searchParams: {},
};

// eslint-disable-next-line default-param-last
export default (state = defaultState, action) => {
  switch (action.type) {
    case REFERRAL_ACTIONS.GET_REFERRAL_REQUEST:
      return {
        ...state,
        searchParams: action.payload,
        referrals: [],
      };
    case REFERRAL_ACTIONS.GET_REFERRAL_SUCCESS:
      return {
        ...state,
        referrals: action.payload.data,
        totalReferrals: action.payload.total,
      };
    case REFERRAL_ACTIONS.GET_REFERRAL_FAILURE:
      // Don't leave the previous total beside an emptied table.
      return {
        ...state,
        referrals: [],
        totalReferrals: 0,
      };
    case REFERRAL_ACTIONS.CANCEL_REFERRAL_SUCCESS: {
      // The monolith response is keyed by the recipient it cancelled, which
      // is the row's `migratedFrom`, not referral-service's own `id`. The
      // monolith response is the authority until referral-service catches up
      // (GOTU-7245).
      const newReferrals = state.referrals.map((r) => {
        if (r.migratedFrom === action.payload?.id) {
          return {
            ...r,
            isCancelled: action.payload.isCancelled,
            cancelledAt: action.payload.cancelledAt,
          };
        }
        return r;
      });
      return {
        ...state,
        referrals: newReferrals,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
